import React, { useState } from "react";

import Typography from "@mui/material/Typography";
import Toolbar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";
import Grid from "@mui/material/Unstable_Grid2";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";

//Selfmade
import { useNavigate, useLocation } from "react-router-dom";
import {
  ButtonBase,
  Menu,
  MenuItem,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";

import { ThemeProvider } from "@emotion/react";
import darkTheme from "../../config/secondaryTheme";
import { Logo } from "../icons/Logo";
import CameraIcon from "../icons/CameraIcon";
import TwoCarsIcon from "../icons/TwoCarsIconsForNarvar";
import SelectPeriod from "../input/selectPeriod";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AddRoadIcon from "@mui/icons-material/AddRoad";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import Divider from "@mui/material/Divider";
import { NavigationTabs } from "../admin/navigationTabs";
import {useAuth} from "../../contexts/AuthContext";

export default function Navbar() {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate();
  const location = useLocation();

  const [anchorElMenu, setAnchorElMenu] = useState(null);

  const handleOpenMenu = (event) => {
    setAnchorElMenu(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorElMenu(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("userInfo");
    navigate("/login");
  };

  const handlePageChange = (event, newPage) => {
    navigate(newPage);
  };

  const isAdminPage =
    isAuthenticated && location.pathname.includes("/administration");

  const isMaintenancePage = location.pathname === "/maintenance";

  const isCurbsidePage = location.pathname === "/curbside";

  const pageHeading = isAdminPage
    ? "Administration"
    : isCurbsidePage
    ? "Curbside"
    : "";

  return (
    <AppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Toolbar>
        <Grid
          container
          justifyContent="space-between"
          sx={{
            width: "100%",
          }}
        >
          <Grid display="flex" alignItems="center">
            <Logo color="white" size="45" />
            <Typography
              variant="h6"
              component="h1"
              sx={{
                fontWeight: 600,
                pl: 2,
                display: { xs: "none", lg: "block" },
              }}
            >
              Bellevue Transportation Dept
            </Typography>
          </Grid>
          {isAdminPage && (
            <ThemeProvider theme={darkTheme}>
              <NavigationTabs />
            </ThemeProvider>
          )}
          <Grid display="flex" alignItems="center" gap="32px">
            {!isAdminPage && !isCurbsidePage && (
              <ThemeProvider theme={darkTheme}>
                <ToggleButtonGroup
                  value={location.pathname}
                  exclusive
                  onChange={handlePageChange}
                >
                  <ToggleButton
                    value={isMaintenancePage ? "/" : location.pathname}
                    sx={{
                      zIndex: isMaintenancePage ? 0 : 1,
                      pr: isMaintenancePage ? 6 : null,
                    }}
                  >
                    <TwoCarsIcon selected={!isMaintenancePage} />
                    Traffic Operations
                  </ToggleButton>
                  <ToggleButton value="/maintenance">
                    <CameraIcon selected={isMaintenancePage} />
                    Device Maintenance
                  </ToggleButton>
                </ToggleButtonGroup>

                {isAuthenticated && <SelectPeriod />}
              </ThemeProvider>
            )}
            {isAuthenticated ? (
              <>
                {pageHeading && (
                  <ThemeProvider theme={darkTheme}>
                    <Typography variant="h6" component="h2">
                      {pageHeading}
                    </Typography>
                  </ThemeProvider>
                )}
                <IconButton
                  size="large"
                  edge="end"
                  color="inherit"
                  aria-label="menu"
                  onClick={handleOpenMenu}
                  sx={{
                    "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
                    backgroundColor: Boolean(anchorElMenu)
                      ? "rgba(255, 255, 255, 0.25)"
                      : "transparent",
                  }}
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  open={Boolean(anchorElMenu)}
                  onClose={handleCloseMenu}
                  onClick={handleCloseMenu}
                  anchorEl={anchorElMenu}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <MenuItem
                    key="dashboard"
                    onClick={() => navigate("/")}
                    sx={{
                      height: "36px",
                    }}
                    selected={location.pathname === "/" || isMaintenancePage}
                  >
                    <IconButton>
                      <DashboardIcon />
                    </IconButton>
                    Dashboard
                  </MenuItem>
                  <MenuItem
                    key="curbside"
                    onClick={() => navigate("/curbside")}
                    sx={{
                      height: "36px",
                    }}
                    selected={location.pathname === "/curbside"}
                  >
                    <IconButton>
                      <AddRoadIcon />
                    </IconButton>
                    Curbside
                  </MenuItem>
                  <MenuItem
                    key="administration"
                    onClick={() => navigate("/administration/intersections")}
                    sx={{
                      height: "36px",
                    }}
                    selected={
                      location.pathname === "/administration/intersections"
                    }
                  >
                    <IconButton>
                      <SettingsIcon />
                    </IconButton>
                    Administration
                  </MenuItem>
                  <Divider />

                  <MenuItem
                    key="logout"
                    onClick={handleLogout}
                    sx={{
                      height: "36px",
                    }}
                  >
                    <IconButton>
                      <LogoutIcon />
                    </IconButton>
                    Sign out
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <ButtonBase
                color="inherit"
                sx={{ fontWeight: 600 }}
                onClick={() => navigate("/login")}
              >
                Sign in
              </ButtonBase>
            )}
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
}
